export default {
  id: null,
  mensagemForaHorario: null,
  idProvedor: null,
  horarios: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/configuracaoBotmodel.js